export const TOAST_TIMER = 8000;
export const MAX_TOASTS_ON_PAGE = 5;

export const PROTOCOL = import.meta.env.VITE_PROTOCOL;
export const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL;
export const PORT = import.meta.env.VITE_PORT;

export const DEFAULT_COUNTRY_CODE = 'RU' as const;
